<template>
	<!-- 抽盒商品 -->
	<div class="rootDiv">
		<div class="retrieve">
			<div class="retrieveDiv flex flex-ac flex-jb">
				<div class="flex flex-ac">
					<div class="mr-30 flex flex-ac">
						<span class="fs-16 flex1 mr-20">系列名称：</span>
						<!-- 						<el-select class="w-250" v-model="retrieveForm.seriesId" filterable clearable placeholder="请选择"
							@change="handleSeries">
							<el-option v-for="item in seriesList" :key="item.value" :label="item.seriesName" :value="item.id">
							</el-option>
						</el-select> -->
						<el-input class="w-250" v-model="retrieveForm.seriesName"></el-input>
					</div>
				</div>
				<div>
					<el-button type="primary" @click="submitSearch" :disabled="retrieveForm.seriesName?false:true">查询</el-button>
					<el-button type="primary" @click="moreEdit" :disabled="tableData.length > 0?false:true">批量修改</el-button>
				</div>
			</div>
		</div>
		<TableHeightFull class="tableDiv pall-30">
			<!-- 表格 -->
			<EleTable ref="tableRef" slot="table" :tableData="tableData" :columns="columns" height="100%" :border="false"
				v-loading="tabLoading" :row-style="{ cursor: 'pointer' }" @selection-change="handleSelectionChange">
				<template v-slot:img="scope">
					<img :src="scope.row.coverImg" alt="" class="smallImg" v-if="scope.row.coverImg">
				</template>
			</EleTable>
			<!-- 分页 -->
			<!-- <PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableData" /> -->
		</TableHeightFull>
		<!-- 修改时间 -->
		<el-dialog title="修改" :visible.sync="dialogFormVisible" top="20vh" width="30%" @close="formClose">
			<div class="pv-30 flex flex-ac">
				<div class="mr-30">发货日期：</div>
				<el-date-picker v-model="formData.deliverDate" type="date" clearable placeholder="选择日期时间"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="formClose">取 消</el-button>
				<el-button type="primary" @click="affirmDate" :loading="butLoading">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import indexMixin from "@/utils/indexMixin"
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'draws',
		mixins: [indexMixin],
		components: {
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve),
			"CountDown": (resolve) => require(["@/components/CountDown"], resolve),
			"UploadFile": (resolve) => require(["@/components/UploadFile"], resolve),
		},
		computed: {
			...mapState('menu', {
				'boxTypes': state => state.dictList ? state.dictList.box_type : [], //优惠劵类型
			})
		},
		data() {
			return {
				retrieveForm: {
					seriesName: '',
				},
				butLoading: false,
				tabLoading: false,
				columns: [{
						type: 'selection',
						align: 'center',
						width: "30",
						fixed: 'left'
					}, {
						type: 'index',
						label: '序号',
						width: '60',
						align: 'center',
						index: this.indexMethod
					},
					{
						label: '系列名称',
						prop: 'seriesName',
						align: 'left',
						width: '300'
					},
					{
						columnType: 'custom',
						label: '系列图片',
						prop: 'img',
						align: 'left',
						width: '80'
					},
					{
						label: '平台',
						prop: 'sysName',
						align: 'left',
						'show-overflow-tooltip': true
					}, {
						label: '发货日期',
						prop: 'deliverDate',
						align: 'left',
						'show-overflow-tooltip': true
					}, {
						columnType: 'button',
						label: '操作',
						align: 'right',
						fixed: 'right',
						width: '200',
						buttons: [{
							type: 'text',
							text: '修改发货时间',
							fn: this.editDate,
						}]
					},
				],
				tableData: [],
				selectData: '',
				gradeConsumeId: '', //等级id
				dialogFormVisible: false,
				formData: {
					deliverDate: '',
					dtos: []
				},
				isSingle: true
			}
		},
		mounted() {},
		methods: {
			//查询
			submitSearch() {
				this.getTableData()
			},
			//获取表格数据
			getTableData() {
				this.tabLoading = true
				this.$http.get('/OthSys/findSysGoodSeriesList', {
					params: {
						seriesName: this.retrieveForm.seriesName
					}
				}).then(({
					data: result
				}) => {
					this.tabLoading = false
					this.tableData = result.data
					this.pageInfo.total = result.data.total
				}).catch(err => {
					this.tabLoading = false
				})
			},
			// 选择框执行的操作
			handleSelectionChange(val) {
				// 使用 map 创建新的 selectData 数组
				const selectData = val.map(item => ({
					id: item.id,
					sysName: item.sysName
				}));
				console.log('selectData', selectData);
				this.formData.dtos = selectData;
			},
			//单个编辑列表
			editDate(row) {
				let selectData = []
				selectData = [{
					id: row.id,
					sysName: row.sysName
				}]
				this.dialogFormVisible = true
				this.formData.dtos = selectData
			},
			//批量修改
			moreEdit() {
				if (this.formData.dtos.length > 0) {
					this.dialogFormVisible = true
				} else {
					this.$message({
						message: '请选择数据',
						type: 'warning'
					})
				}
			},
			formClose() {
				this.formData.deliverDate = ''
				this.formData.dtos = []
				this.dialogFormVisible = false
			},
			affirmDate() {
				if (!this.formData.deliverDate) {
					return this.$message({
						message: '发货时间不能为空',
						type: 'error'
					})
				}
				this.butLoading = true
				let goodData = JSON.stringify(this.formData.dtos)
				this.$confirm('您确认修改吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					this.$http.post(`/OthSys/editOthSysSeries?deliverDate=${this.formData.deliverDate}`, goodData, {
						headers: {
							'Content-Type': 'application/json'
						}
					}).then(({
						data: result
					}) => {
						this.$message({
							message: '修改成功',
							type: 'success'
						})
						this.butLoading = false
						this.formData.deliverDate = ''
						this.formData.dtos = []
						this.dialogFormVisible = false
						this.getTableData()
					})
				}).catch(_ => {
					this.butLoading = false
				})
			},
			//重置清除校验
			resetForm() {
				Object.assign(
					this.ruleForm,
					this.$options.data().ruleForm
				)
				this.$nextTick(() => {
					this.$refs.ruleForm.clearValidate()
				})
			},
		},
	}
</script>

<style lang="less" scoped>
</style>